module.exports = __webpack_public_path__ + "static/media/logo1.8613fb32.svg";